import { createContext, useContext } from 'react';
import type { AppColorMode } from '../theme';

export type ColorMode = AppColorMode;

export const ColorModeContext = createContext<{ mode: ColorMode; toggle: () => void }>({
  mode: 'light',
  toggle: () => {},
});

export const useColorMode = () => useContext(ColorModeContext);
